module.exports = __webpack_public_path__ + "static/media/1 8 arm god roman god angel wings clouds.1280x1929.3a65e89b.webp";